export const dHeaders = (dheaders = [dHeader()]) => dheaders.map(dHeader);

export const dHeader = (dheaderObj) => {
  const {
    text = '',
    value = '',
    type = DHeaderTypes.Text,
    selectable = false,
    placeholder = '',
    valueFunc,
    ta = 'left',
  } = dheaderObj;
  return {
    ...dheaderObj,
    text,
    value,
    type,
    selectable,
    placeholder,
    valueFunc,
    ta,
  };
}



export const DHeaderTypes = {
  Text: 'Text',
  TextField: 'TextField',
  Checkbox: 'Checkbox',
  Button: 'Button'
}